import DOMPurify from 'dompurify';
import { useMemo } from 'react';

import type { Message } from './ReachProSupportChatPanel';
import * as styles from './ReachProSupportMessage.css';

interface ReachProSupportMessageProps {
  message: Message;
}

export function ReachProSupportMessage({
  message,
}: ReachProSupportMessageProps) {
  const sanitizedContent = useMemo(() => {
    return DOMPurify.sanitize(message.content, {
      ALLOWED_TAGS: [
        'br',
        'div',
        'p',
        'span',
        'b',
        'i',
        'strong',
        'em',
        'ul',
        'ol',
        'li',
        'a',
      ],
      ALLOWED_ATTR: ['href', 'target', 'rel'],
    });
  }, [message.content]);

  return (
    <div
      className={`${styles.messageBubble} ${
        message.isSent ? styles.messageBubbleSent : styles.messageBubbleReceived
      }`}
    >
      <div className={styles.messageHeader}>
        {message.senderName}
        <span className={styles.messageTimestamp}>
          {' • '}
          {message.timestamp.toLocaleString([], {
            month: '2-digit',
            day: '2-digit',
            year: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
          })}
        </span>
      </div>
      <div
        className={styles.messageContent}
        dangerouslySetInnerHTML={{ __html: sanitizedContent }}
      />
    </div>
  );
}
